/* eslint-disable no-unused-vars */
import * as React from 'react';
import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableSortLabel,
  TableHead,
} from '@material-ui/core';
import { ArrowDrop } from '../Modals/UOAModal/components/ModalArrowDrop';
import styles from './index.styles';
import { useSelector } from 'react-redux';
import { useState } from 'react';

export default function CustomDataTable({
  columns,
  loading,
  rows,
  clickHanlder,
  error,
}) {
  const { isMobile } = useSelector((state) => state.appReducer);
  const [orderBy, setOrderBy] = useState('');
  const [order, setOrder] = useState('');
  const [rowsData, setRowsData] = useState([]);

  const [hoverTabelSortLabel, sethoverTabelSortLabel] = useState(0);

  React.useEffect(() => {
    if (rows.length) setRowsData(rows);
    return () => {
      setRowsData([]);
    };
  }, [rows]);

  const sortData = (keyName, sortFunc) => {
    let sortOrder;
    if (orderBy === keyName) sortOrder = order === 'asc' ? 'desc' : 'asc';
    if (orderBy !== keyName) sortOrder = 'desc';

    // const isSameKey = orderBy === keyName && order;
    // const isAsc = orderBy === keyName && order === 'asc';
    // const orderType = isAsc ? 'desc' : 'asc';
    setOrderBy(keyName);
    setOrder(sortOrder);
    const res = sortFunc(rowsData, sortOrder, orderBy);
    setRowsData(res);
  };

  return (
    <React.Fragment>
      <Table>
        <TableHead>
          <TableRow style={styles.tableRow}>
            {columns.map(({ title, sortKey, sortFunc, style, keyName }, i) => (
              <TableCell
                key={i}
                style={{
                  ...styles.modalTableHeaderCell,
                  ...style.headCellStyle,
                }}
                className="sticky"
                align="right"
              >
                {sortFunc ? (
                  <TableSortLabel
                    onMouseOver={() => sethoverTabelSortLabel(i + 1)}
                    onMouseOut={() => sethoverTabelSortLabel('')}
                    style={style.headCellStyle.sortLabelStyle}
                    active={orderBy === sortKey}
                    direction={orderBy === sortKey ? order : 'asc'}
                    disabled={clickHanlder ? false : true}
                    onClick={() => {
                      if (sortFunc) sortData(keyName, sortFunc);
                    }}
                    IconComponent={() => (
                      <ArrowDrop
                        orderBy={orderBy}
                        active={orderBy === keyName}
                        hover={hoverTabelSortLabel}
                        propertyName={i + 1}
                        direction={orderBy === keyName ? order : ''}
                      />
                    )}
                  >
                    {title}
                  </TableSortLabel>
                ) : (
                  title
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        {loading && (
          <TableBody>
            <TableRow>
              <TableCell colSpan={12}>
                <CircularProgress
                  style={{
                    marginTop: '50px',
                  }}
                  size={24}
                  color="primary"
                />
              </TableCell>
            </TableRow>
          </TableBody>
        )}

        {rowsData.length > 0 && !loading ? (
          <TableBody>
            {rowsData.map((row, index) => (
              <TableRow
                key={index}
                style={
                  index % 2
                    ? { background: '#e5e5e5', height: '25px' }
                    : { background: 'white', height: '25px' }
                }
              >
                {columns.map(
                  ({
                    title,
                    keyName,
                    style,
                    prefix,
                    upDown,
                    func,
                    hoverColor,
                    hoverClassName,
                  }) => (
                    <TableCell
                      key={keyName}
                      style={{
                        ...styles.modalTableRow,
                        ...style.bodyCellStyle,
                        color:
                          upDown === true
                            ? +row[keyName] > 0
                              ? 'green'
                              : 'red'
                            : 'unset',
                        transition: 'background-color 0.3s ease',
                        '&:hover': {
                          ...style.bodyCellStyle.hoverStyle, // Merge in the dynamic hover styles
                        },
                      }}
                      onClick={async () => clickHanlder(row, keyName)}
                      className={
                        hoverClassName && hoverColor === 'white'
                          ? 'toggleCellsWhite'
                          : hoverColor === 'purple'
                          ? 'toggleCells'
                          : ''
                      }
                    >
                      {prefix ? prefix : ''}
                      {func ? func(row[keyName]) : row[keyName]}
                    </TableCell>
                  )
                )}
              </TableRow>
            ))}
          </TableBody>
        ) : null}
      </Table>

      {error != null && !loading && isMobile ? (
        <div
          style={{
            backgroundColor: '#f2f2f2',
            height: '70px',
            width: '100%',
            textAlign: 'center',
            paddingTop: '60px',
          }}
        >
          {' '}
          {error}
        </div>
      ) : (
        ''
      )}
      {error != null && !loading && !isMobile ? (
        <div
          style={{
            backgroundColor: '#f2f2f2',
            height: '70px',
            width: '100%',
            textAlign: 'center',
            paddingTop: '60px',
          }}
        >
          {' '}
          {error}
        </div>
      ) : (
        ''
      )}

      {rows.length === 0 && !loading && error == null && isMobile ? (
        <div
          style={{
            backgroundColor: '#f2f2f2',
            height: '70px',
            width: '100%',
            textAlign: 'center',
            paddingTop: '60px',
          }}
        >
          {' '}
          Please Enter Stock Ticker
        </div>
      ) : (
        ''
      )}
      {rows.length === 0 && !loading && error == null && !isMobile ? (
        <div
          style={{
            backgroundColor: '#f2f2f2',
            height: '70px',
            width: '100%',
            textAlign: 'center',
            paddingTop: '60px',
          }}
        >
          {' '}
          Please Enter Stock Ticker
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomDataTable/index.jsx